import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CoreDialogController } from '@core-modules/providers/core-dialogs/core-dialog-controller';
import { CreateAccountEndResult } from 'authorization/models/create-account-end-result';
import { AuthProvider } from 'authorization/providers/auth/auth-provider';

@Injectable({
    providedIn: 'root'
})
export class CreateAccountEntryResolverService  {

    //#region Constructor
    /**
     * Class Constructor
     */
    constructor(
        private auth: AuthProvider,
        private coreDialog: CoreDialogController
    ) 
    {
    }

    //#endregion


    //#region Methods
    /**
     * 
     * @param route 
     * @returns return url from azure
     */
    async resolve(route: ActivatedRouteSnapshot): Promise<CreateAccountEndResult>
    {
        let returnUrl = route.queryParamMap.get('param');

        await this.coreDialog.showLoader();
        // show a loading spinner
        let createAccountEndResult = await this.auth.createAccountEnd(returnUrl);
        await this.coreDialog.hideLoader();
        return Promise.resolve(createAccountEndResult);
    }

    //#endregion

}